(function ($) {
 'use strict';

 var host = location.protocol + '//' + location.host;
 var win = $(window);
 var doc = $(document);
 var modifiedLocation = false;
 var DEFAULT_REGION = 'southeast';
 var ALL_REGIONS = 'all-regions';
 var Filter = {

  filters: {
   region: null,
   profile: null,
   weight: null,
   color: null,
   search: null,
   sort: null,
   compare: null,
   pg: 1, //pagination
   pd: null,
  },

  pagable: true,

  initialized: false,

  initialize: function () {
   if (this.initialized) {
    return;
   }
   this.initialized = true;
   this.build();
   this.events();
   $('.loader').slideDown(300);

  },

  build: function () {
   this.main.build();
   this.sidebar.build();
   this.setFiltersFromQuery();
  },

  events: function () {
   this.main.events();
   this.sidebar.events();

   var self = this;
   doc.ready(function () {
    self.main.loadResults();
    self.sidebar.loadFilters();
   });

   window.onpopstate = function () {
    $('.lb-close').get(0).click();
    Filter.initialized = false;
    Filter.initialize();
    // Filter.main.loadResults();
    //Filter.sidebar.loadFilters();
   };

  },

  sidebar: {
   contentElement: $('.sidebar-results .content'),

   build: function () {
    this.hideRegionFilter();
    this.bindFiltersFromQuery();
   },

   events: function () {
    doc.on('click', '#changeRegion', function () {
     Filter.sidebar.showRegionFilter();
     return false;
    });

    doc.on('change', '#region', function () {
     //                    $('#datacontent').addClass('loading');
     var region = $(this).val();
     var regionText = Filter.formatDashedString(region);
     console.log(region);
     Filter.filters.region = region;
     Filter.filters.search = null;
     Filter.filters.compare = null;
     Filter.sidebar.loadFilters();
     Filter.sidebar.clearAllFilters();
     Filter.main.loadResults();
     $('#searchForm input.region').val(region);
     $('#currentRegion').text(regionText);
    });

    doc.on('click', '#sidebar-search-btn', function (e) {
     e.preventDefault();
     var search = $('#sidebar-search-input').val();
     if (search !== '') {
      Filter.sidebar.clearAllFiltersNoLoad();
      Filter.filters.search = search;
      Filter.main.loadResults();
     }
    });

    doc.on('click', '[id^=tileOption]', function () {

     console.log($(this).attr('id').replace('tileOption-', ''));

     Filter.filters.search = null;
     Filter.filters.compare = null;
     var profiles = $('[id^=tileOption].selected');
     var profilesArray = [];

     profiles.each(function () {
      profilesArray.push($(this).attr('id').replace('tileOption-', ''));
     });

     Filter.filters.profile = profilesArray;
     Filter.main.loadResults();

     if (Filter.filters.profile.length === 1) {
      Filter.main.showProfileHeader(Filter.filters.profile[0]);
     } else {
      Filter.main.hideProfileHeader();
     }
     $('.facade-group.open').removeClass('open');
     console.log(profiles);
     console.log(profilesArray);

     //                  return false;
    });

    doc.on('click', '[id^=weightOption]', function () {

     Filter.filters.search = null;
     Filter.filters.compare = null;
     var weights = $('[id^=weightOption].selected');
     var weightsArray = [];

     weights.each(function () {
      weightsArray.push($(this).attr('id').replace('weightOption-', ''));
     });
     $('#datacontent').addClass('loading');

     Filter.filters.weight = weightsArray;
     Filter.main.loadResults();
     $('.facade-group.open').removeClass('open');
     //                  return false;
    });

    doc.on('click', '[id^=colorOption]', function () {

     Filter.filters.search = null;
     Filter.filters.compare = null;
     var colors = $('[id^=colorOption].selected');
     var colorsArray = [];

     colors.each(function () {
      colorsArray.push($(this).attr('id').replace('colorOption-', ''));
     });
     $('#datacontent').addClass('loading');

     Filter.filters.color = colorsArray;
     Filter.main.loadResults();
     $('.facade-group.open').removeClass('open');
     //                  return false;

    });

    doc.on('click', '.clearFilters', function () {

     $('#datacontent').addClass('loading');
     Filter.sidebar.clearAllFilters();
     return false;
    });

     $('.scrollTop').click(function (e) {
       e.preventDefault();

      $('html,body').animate({
        scrollTop: Filter.main.contentElement.offset().top - 100
      }, 1000);
     })
   },

   hideRegionFilter: function () {
    //                $('#selectRegion').hide();
   },

   showRegionFilter: function () {
    //                $('#selectRegion').slideDown();
   },

   clearAllFilters: function (noload) {

    var region = Filter.filters.region;
    for (var key in Filter.filters) {
     Filter.filters[key] = null;
    }
    Filter.filters.region = region;

    Filter.main.loadResults();
    Filter.sidebar.unbindFilters();
    Filter.main.hideProfileHeader();
    //                window.scrollTo(0,0);
   },
   clearAllFiltersNoLoad: function () {
    var region = Filter.filters.region;
    for (var key in Filter.filters) {
     Filter.filters[key] = null;
    }
    Filter.filters.region = region;
    Filter.sidebar.unbindFilters();
    Filter.main.hideProfileHeader();
    //                window.scrollTo(0,0);
   },

   loadFilters: function () {
    //                $('#datacontent').addClass('loading');

    $.ajax({
     type: "GET",
     cache: false,
     data: 'region=' + (Filter.filters.region),
     dataType: 'json',
     url: host + '/wp-content/themes/eagl/sidebarhandler.php',
     success: function (data) {
      var availableProfiles = data.profiles;
      var availableWeights = data.weights;
      var availableColors = data.colors;

      Filter.sidebar.showDesktopFilters(availableProfiles, availableWeights, availableColors);
      Filter.sidebar.showMobileFilters(availableProfiles, availableWeights, availableColors);

     },
     error: function (jqXHR, textStatus, errorThrown) {
      //                        alert(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
     }
    });
   },

   showMobileFilters: function (availableProfiles, availableWeights, availableColors) {

    var allOption = '<option value="all">All</option>';

    //Hide all Profiles
    $('#mobileProfileFilter option').remove();
    $('#mobileProfileFilter').append(allOption);

    //Show Available Profiles
    if (availableProfiles.length > 0) {
     $('#mobile-no-profiles').hide();
     for (var i = 0; i < availableProfiles.length; i++) {
      var profile = availableProfiles[i];
      var profileText = Filter.formatDashedString(profile);

      $('#mobileProfileFilter').append('<option value="' + profile + '">' + profileText + '</option>');
     }
    } else {
     $('#mobile-no-profiles').show();
    }

    //Hide all Weights
    $('#mobileWeightFilter option').remove();
    $('#mobileWeightFilter').append(allOption);

    //Show Available Weights
    if (availableWeights.length > 0) {
     $('#mobile-no-weights').hide();
     for (var j = 0; j < availableWeights.length; j++) {
      var weight = availableWeights[j];
      var weightText = Filter.formatDashedString(weight);

      $('#mobileWeightFilter').append('<option value="' + weight + '">' + weightText + '</option>');
     }
    } else {
     $('#mobile-no-weights').show();
    }

    //Hide all Weights
    $('#mobileColorFilter option').remove();
    $('#mobileColorFilter').append(allOption);

    //Show Available Weights
    if (availableColors.length > 0) {
     $('#mobile-no-colors').hide();
     for (var k = 0; k < availableColors.length; k++) {
      var color = availableColors[k];
      var colorText = Filter.formatDashedString(color);

      $('#mobileColorFilter').append('<option value="' + color + '">' + colorText + '</option>');
     }
    } else {
     $('#mobile-no-colors').show();
    }
   },

   showDesktopFilters: function (availableProfiles, availableWeights, availableColors) {

    //Hide all Profiles
    $('[id^=tileOption]').hide();

    //Show Available Profiles
    if (availableProfiles.length > 0) {
     $('#no-profiles').hide();
     for (var i = 0; i < availableProfiles.length; i++) {
      var profile = availableProfiles[i];
      $('#tileOption-' + profile).show();
     }
    } else {
     $('#no-profiles').show();
    }

    //Hide all Weights
    $('[id^=weightOption]').hide();

    //Show Available Weights
    if (availableWeights.length > 0) {
     $('#no-weights').hide();
     for (var j = 0; j < availableWeights.length; j++) {
      var weight = availableWeights[j];
      $('#weightOption-' + weight).show();
     }
    } else {
     $('#no-weights').show();
    }

    //Hide all Colors
    $('[id^=colorOption]').hide();

    //Show Available Colors
    if (availableColors.length > 0) {
     $('#no-colors').hide();
     for (var k = 0; k < availableColors.length; k++) {
      var color = availableColors[k];
      $('#colorOption-' + color).show();
     }
    } else {
     $('#no-colors').show();
    }
   },

  unbindFilters: function () {
    var $filters = $('.sidebar-results .content');
    $('#sort-input option').each(function () {
     $(this).removeAttr('selected');
    });
    $filters.find('[id^=tileOption]').each(function () {
     $(this).removeClass('selected');
    });
    $filters.find('[id^=weightOption]').each(function () {
     $(this).removeClass('selected');
    });
    $filters.find('[id^=colorOption]').each(function () {
     $(this).removeClass('selected');
    });
   },

   bindFiltersFromQuery: function () {

    function displaySearchtitle() {
     var region = Filter.getParameterByName('region') || ALL_REGIONS;
     var profiles = Filter.getParameterByName('profile');

     if (profiles !== null) {
      $('.banner .search-title, .results-banner h5 span').text(profiles.replace(/,/gi, ', ').replace(/-/gi, ' ') + ' - ' + region.replace(/-|pacific/gi, ' '));
      $('.search-title-dupe').text($('.results-banner h5').text());

     } else {

      $('.banner .search-title, .results-banner h5 span').text('All Profiles - ' + region.replace(/-|pacific/gi, ' '));
      $('.search-title-dupe').text($('.results-banner h5').text());
     }

    }

    //Bind Selected Region
    (function () {
     var region = Filter.getParameterByName('region');
     var regionText = Filter.formatDashedString(region);

     if (region !== null) {
      $('#region option').each(function () {
       $(this).removeAttr('selected');
      });
       //console.log('binding change!', $('#region').val(), region);
      // $('#region option[value=' + region + ']').attr('selected', 'selected');
      $('#region').val(region);
      $('#searchForm input.region').val(region);
      $('#currentRegion').text(regionText);
     }
    })();

    //Bind Header Profiles
    (function () {
     var profiles = Filter.getParameterByName('profile');
     var region = Filter.getParameterByName('region');

     if (profiles !== null) {
      var profilesArray = profiles.split(',');
      if (profilesArray.length === 1) {
       Filter.main.showProfileHeader(profilesArray[0]);
      }

      displaySearchtitle();

     }

    })();

    //Bind Selected Profiles
    (function () {
     var profiles = Filter.getParameterByName('profile');

     //                    console.log(profiles);
     if (profiles !== null) {
      var profilesArray = profiles.split(',');

      $('.sidebar-results .content [id^=tileOption]').each(function () {
       $(this).removeClass('selected');
      });

      for (var i = 0; i < profilesArray.length; i++) {
       var profile = profilesArray[i];
       //console.log(profile);

       $('#tileOption-' + profile).addClass('selected');
      }
     }
     displaySearchtitle();
    })();

    //Bind Selected Weights
    (function () {
     var weights = Filter.getParameterByName('weight');
     var region = Filter.getParameterByName('region');
     var profiles = Filter.getParameterByName('profile');

     // console.log(weights);
     if (weights !== null) {
      var weightsArray = weights.split(',');

      $('.sidebar-results .content [id^=weightOption]').each(function () {
       $(this).removeClass('selected');
      });

      for (var i = 0; i < weightsArray.length; i++) {
       var weight = weightsArray[i];

       $('#weightOption-' + weight).addClass('selected');

      }

      displaySearchtitle();

     }
    })();

    //Bind Selected Colors
    (function () {
     var colors = Filter.getParameterByName('color');
     var region = Filter.getParameterByName('region');
     var profiles = Filter.getParameterByName('profile');

     if (colors !== null) {
      var colorsArray = colors.split(',');

      $('.sidebar-results .content [id^=colorOption]').each(function () {
       $(this).removeClass('selected');
      });

      for (var i = 0; i < colorsArray.length; i++) {
       var color = colorsArray[i];

       $('#colorOption-' + color).addClass('selected');

      }

      displaySearchtitle();
     }
    })();

    //  If they ask to show the search query in the search input box:
    //  window.requestAnimationFrame(function () {
    //    var search = Filter.getParameterByName('search');
    //    $('#searchForm input.search').val(search);
    //  });

   },
  },

  main: {
   contentElement: $('#datacontent'),

   build: function () {
    this.hideProfileHeader();
   },

   events: function () {

    doc.on('change', '#sort-input', function () {
     var sort = $('#sort-input').val();
     if (sort !== '') {
      Filter.filters.sort = sort;
      Filter.main.loadResults();
     }
    });

    doc.on('click', '#compare-button, #mobile-compare-button', function () {
     var compareArray = [];
     $('#loadMoreResults').hide();

     $('.compare-input:checked').each(function () {
      compareArray.push($(this).val());
     });

     if (compareArray.length > 1) {
      Filter.filters.compare = compareArray;
      Filter.main.loadResults();
     } else {
      Filter.filters.compare = null;
      alert('Please select at least 2 items to compare.');
     }

     return false;
    });

    doc.on('click', '#applyMobileSort', function () {
     var sort = $('#mobile-sort-input').val();

     if (sort === 'none') {
      Filter.filters.sort = null;
     } else {
      Filter.filters.sort = sort;
     }

     Filter.main.loadResults();

     $('html,body').animate({
      scrollTop: Filter.main.contentElement.offset().top - 15
     }, 1000);

    });

    doc.on('click', '#applyMobileFilters', function () {
     var profile = $('#mobileProfileFilter').val();
     var weight = $('#mobileWeightFilter').val();
     var color = $('#mobileColorFilter').val();
     var profilesArray = [];
     var weightsArray = [];
     var colorsArray = [];

     if (profile === 'all') {
      Filter.filters.profile = null;
     } else {
      profilesArray.push(profile);
      Filter.filters.profile = profilesArray;
     }

     if (weight === 'all') {
      Filter.filters.weight = null;
     } else {
      weightsArray.push(weight);
      Filter.filters.weight = weightsArray;
     }

     if (color === 'all') {
      Filter.filters.color = null;
     } else {
      colorsArray.push(color);
      Filter.filters.color = colorsArray;
     }

     Filter.main.loadResults();

     $('html,body').animate({
      scrollTop: Filter.main.contentElement.offset().top - 15
     }, 1000);
    });

    $("#loadMoreResults").unbind('click').bind('click', function () {
     if (Filter.pagable) {
      Filter.main.appendResults();
     }
    });

    // Add the id to a query parameter when a user clicks a search result link
    $(document).on('click', '.searchResult a', function (e) {
      // If user is trying to open a new tab, do nothing
      if (e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey) {
        return true;
      }

      var $link = $(this);
      var id = $link.closest('.searchResult').data('product-id');

      // Make sure this is a proper link and not something...else
      if ($link.attr('href').length > 10) {
        e.preventDefault();
        Filter.filters.pd = id;
        Filter.pushUrlString();

        window.requestAnimationFrame(function () {
          setTimeout(function () {
            location.href = $link.attr('href');
          }, 500);
        })
      }
    });
   },

   loadResults: function (cache) {
    cache = cache || false;
    // console.log("asdasdasd" + Filter.buildQueryString());
    //                $('#loadingGif').fadeIn();
    $('#datacontent').addClass('loading');
    $('#noAdditionalResults').fadeOut();
    $.ajax({
     type: "GET",
     cache: cache,
     data: Filter.buildQueryString() + '&show_all_pages=true',
     url: host + '/wp-content/themes/eagl/loophandler.php',
     success: function (data) {
      if (Filter.filters.pg === null) {
       Filter.filters.pg = 1;
      }
      Filter.main.contentElement.html(data);
      Filter.pushUrlString();
      Filter.pagable = true;

       if (Filter.filters.pd !== null) {
        var $searchParamResult = $('[data-product-id="' + Filter.filters.pd + '"]');

        if ($searchParamResult.length) {
          $('html,body').animate({
          scrollTop: $searchParamResult.offset().top - 100
          }, 1000);
        } else {
          console.warn('Dev Message: Filter.js has reached an unhandled condition.. please resolve');
        }
      }

      $('#loadingGif').fadeOut();
      $('#datacontent').removeClass('loading');
      if (Filter.filters.compare === null) {
       $('#loadMoreResults').fadeIn();
      }

      if (data.trim().indexOf('No results were found with your criteria.') > 0) {
       $('#loadMoreResults').fadeOut();
      }

      if ($('html').hasClass('history')) {

       if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
       }

       $('.lightbox-link').click(function () {
        var pushUrl = $(this).attr('href').replace(location.origin, '');
        window.history.pushState('obj', $(this).attr('href'), pushUrl);
        return true;
       });

      }

      var region = Filter.getParameterByName('region') || ALL_REGIONS;
      var profiles = Filter.getParameterByName('profile');

      if (profiles !== null) {
       $('.banner .search-title, .results-banner h5 span').text(profiles.replace(/,/gi, ', ').replace(/-/gi, ' ') + ' - ' + region.replace(/-|pacific/gi, ' '));
       $('.search-title-dupe').text($('.results-banner h5').text());

      } else {

       $('.banner .search-title, .results-banner h5 span').text('All Profiles - ' + region.replace(/-|pacific/gi, ' '));
       $('.search-title-dupe').text($('.results-banner h5').text());
      }

      Filter.pushUrlString();

      Filter.fbShareEvents();

     },
     error: function (jqXHR, textStatus, errorThrown) {
      //                        alert(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
     }
    });
   },

   appendResults: function () {
    Filter.filters.pg = parseInt(Filter.filters.pg) + 1;
    $('#datacontent').addClass('loading');
    $('#loadingGif').fadeIn();
    $.ajax({
     type: "GET",
     cache: false,
     data: Filter.buildQueryString(),
     url: host + '/wp-content/themes/eagl/loophandler.php',
     success: function (data) {
      Filter.pushUrlString();
      if (data.trim() !== '' && !Filter.filters.search) {
       Filter.main.contentElement.append(data);
      } else {
       Filter.pagable = false;
       if (parseInt(Filter.filters.pg) > 1) {
        Filter.filters.pg = parseInt(Filter.filters.pg) - 1;
       }
       $('#loadMoreResults').fadeOut();
       $('#noAdditionalResults').fadeIn();
      }
      $('#loadingGif').fadeOut();

     },
     error: function (jqXHR, textStatus, errorThrown) {
      if (parseInt(Filter.filters.pg) > 1) {
       Filter.filters.pg = parseInt(Filter.filters.pg) - 1;
      }
      //                        alert(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
     }
    });
   },

   hideProfileHeader: function () {
    $('#single-profile').hide();
   },

   showProfileHeader: function (profile) {
    $('#single-profile h1').text(Filter.formatDashedString(profile.toUpperCase()));
    $('#single-profile img').attr('src', host + '/wp-content/themes/eagl/assets/img/profile-headers/' + profile + '.svg');
    $('#single-profile').show();
   },
  },

  formatDashedString: function (dashedString) {
   if (dashedString !== null) {
    var formattedString = dashedString.replace(/\-/g, ' ').replace(/\w\S*/g, function (txt) {
     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    return formattedString;
   }
  },

  getParameterByName: function (name) {
   name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
   var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
   return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
  },

  setFiltersFromQuery: function () {
   for (var key in this.filters) {
    var value;
    if (this.getParameterByName(key) === 'all' || this.getParameterByName(key) === '') {
     value = null;
    } else {
     value = this.getParameterByName(key);
    }
    this.filters[key] = value;
   }
  },

  buildQueryString: function () {
   var queryString = '';
   // console.log(this.filters);
   for (var key in this.filters) {
    // console.log('key '+ key + ' = ' + this.filters[key]);
    if (this.filters[key] !== null && this.filters[key] !== '') {

     // this.filters
     queryString += key + '=' + this.filters[key] + '&';
     // console.log(queryString);
    }
   }
   // console.log('qs' + queryString.substring(0, queryString.length - 1));
   return queryString.substring(0, queryString.length - 1);
  },

   pushUrlString: function () {
    //  if (modifiedLocation) {
       window.history.replaceState('', null, '?' + this.buildQueryString());

    //   } else {
    //    window.history.pushState('', null, '?' + this.buildQueryString());
    //    modifiedLocation = true;
    // }
  },

  fbShareEvents: function () {
   //console.log('initted');

   var img = $($('#datacontent').first('.searchResult')).find('img').attr('src');

   $('#search-image').attr('src', img).animate({

    'opacity': 1

   })

   //console.log(img);
  }
 };

 if ($('.page-tile-results').length) {

  Filter.initialize();

 }

  //console.log('Filter', Filter);

})(jQuery);
